const getStyleForIframe = function (url, linkId, iframeId, dom) {
    return new Promise((resolve, reject) => {
        let DOM = dom;
        if (iframeId) {
            const iFrame = document.getElementById(iframeId);
            let framedoc = iFrame.contentDocument;
            if (!framedoc && iFrame.contentWindow) {
                framedoc = iFrame.contentWindow.document;
            }

            DOM = iFrame.contentWindow || iFrame.contentDocument || document;
            if (DOM.document) {
                DOM = DOM.document;
            }
        }

        const link = DOM.createElement('link');
        const head = DOM.head || DOM.getElementsByTagName('head')[0] || DOM.documentElement;
        if (DOM.getElementById(linkId)) {
            // if already exists remove it
            head.removeChild(DOM.getElementById(linkId));
        }

        link.href = url;
        link.id = linkId;
        link.type = 'text/css';
        link.rel = 'stylesheet';

        head.insertBefore(link, head.firstChild);
        link.onload = link.onreadystatechange = function () {
            resolve(this);
        };
    });
};
export default getStyleForIframe;
